import { Box, MenuItem, Select } from "@mui/material";

import { AdminGetRoutesDriverResDto } from "service/api/estabrookSchemas";
import { ControlledSelectOption, Disconnected, makeSxStyles } from "ui";

type DriverControlledSelectProps = {
  driver?: AdminGetRoutesDriverResDto;
  availableForAnyDriver: boolean;
  driverOptions: ControlledSelectOption[];
  handleDriverChange: (value: string) => void;
  isDisconnected: boolean;
};

const DriverControlledSelect = ({
  driver,
  availableForAnyDriver,
  driverOptions,
  handleDriverChange,
  isDisconnected,
}: DriverControlledSelectProps) => {
  const styles = useStyles();
  return (
    <Select
      displayEmpty
      disableUnderline
      size="small"
      variant="filled"
      value={
        !driver?.id && !availableForAnyDriver
          ? "No Driver"
          : availableForAnyDriver
            ? "Any"
            : driver?.id
      }
      onChange={(evt) => handleDriverChange(evt.target.value)}
      renderValue={(selected) => {
        if (selected === "none") {
          return "Select Driver";
        }
        const selectedOption = driverOptions.find((o) => o.value === selected);
        return (
          <Box sx={styles.connectivity}>
            {selectedOption?.selectedLabel || selectedOption?.label}
            {isDisconnected && <Disconnected />}
          </Box>
        );
      }}
      MenuProps={{
        PaperProps: {
          sx: styles.menuItem,
          style: {
            maxHeight: 400,
            maxWidth: 400,
          },
        },
      }}
      sx={styles.select}
    >
      {driverOptions.map((o) => (
        <MenuItem
          disabled={o.disabled}
          key={o.value}
          value={o.value}
          data-testid="drowpdown-item"
        >
          {o.label}
        </MenuItem>
      ))}
    </Select>
  );
};

const useStyles = makeSxStyles(({ palette: { grey } }) => ({
  menuItem: {
    color: grey[100],
  },
  connectivity: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  select: {
    "&.MuiSelect-filled": {
      padding: "2px 32px 2px 8px !important",
      minHeight: "unset !important",
      height: "auto !important",
    },
    "& .MuiSelect-select": {
      padding: "2px 32px 2px 8px !important",
      minHeight: "unset !important",
      height: "auto !important",
    },
    "& .MuiSelect-icon": {
      right: "8px !important",
    },
  },
}));

export default DriverControlledSelect;
